import LaborTimeSection from './LaborTimeSection';

export default LaborTimeSection;
